import { inputAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';
import { theme as defaultTheme } from '@chakra-ui/theme';
import { StyleFunctionProps } from '@chakra-ui/theme-tools';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);

const size = {
  lg: defineStyle({
    fontSize: 'lg',
    px: '2',
    h: '10',
    borderRadius: 'md',
  }),
  md: defineStyle({
    fontSize: 'md',
    px: '2',
    h: '34px',
    borderRadius: 'md',
  }),
  sm: defineStyle({
    fontSize: 'sm',
    px: '2',
    h: '6',
    borderRadius: 'md',
  }),
};

const sizes = {
  lg: definePartsStyle({
    field: size.lg,
    addon: size.lg,
  }),
  md: definePartsStyle({
    field: size.md,
    addon: size.md,
  }),
  sm: definePartsStyle({
    field: size.sm,
    addon: size.sm,
  }),
};

export const Input = defineMultiStyleConfig({
  variants: {
    'admin-outline': (props: StyleFunctionProps) => ({
      ...defaultTheme.components.Input.variants?.outline(props),
      field: {
        ...defaultTheme.components.Input.variants?.outline(props).field,
        borderColor: 'stroke.grey',
        border: '1px solid',
        caretColor: '#0049FF', // It doesn't pick up the color from the theme for some reason
        _hover: {
          borderColor: 'accent.200',
          boxShadow: 'outline',
        },
        _focusVisible: {
          borderColor: 'accent.200',
          boxShadow: 'outline',
        },
        _placeholder: {
          color: 'text.quaternary',
        },
      },
    }),
  },
  sizes,
  defaultProps: {
    size: 'md',
    variant: 'admin-outline',
  },
});
